import React from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import BaseButton from "components/UI/Buttons/BaseButton";
import { TextField } from "redux-form-material-ui";
// import ReactSelect from 'components/UI/Forms/ReactSelect/ReactSelectInput'

const styles = theme => ({
  root: {
    flexGrow: 1,
    fontWeight: 500,
  },
  button: {
    margin: theme.spacing.unit,
    height: 32,
  },
  alignRight: {
    display: "flex",
    justifyContent: "flex-end",
  },
});

const messageCharLimit = 160;

class NotificationsForm extends React.PureComponent {
  handleDiscard = () => {
    this.props.history.goBack();
  };

  render() {
    const {
      handleSubmit,
      pristine,
      reset,
      submitting,
      isEditing,
      classes,
      formInitValues,
      messageValue,
      customerValue
    } = this.props;

    const { customers, regions, equipments, agreements } = formInitValues;

    const messageCharCount = messageValue ? messageValue.length : 0;

    const isAllCustomers = customerValue === '*'
    
    return (
      <div className={classes.root}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={24}>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={16}>
                <Grid item xs={12} sm={12}>
                  <Field
                    name="message"
                    component={TextField}
                    placeholder="Message"
                    label="Message"
                    margin="none"
                    variant="outlined"
                    fullWidth
                    rows={12}
                    multiline
                    error={messageCharCount > messageCharLimit}
                    helperText={`${messageCharCount} / ${messageCharLimit}`}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={3}>
              <Grid container spacing={16}>
                <Grid item xs={12} sm={12}>
                  <Field
                    name="customerId"
                    component={TextField}
                    select
                    placeholder="Customers"
                    label="Customers"
                    variant="outlined"
                    margin="none"
                    fullWidth
                    autoFocus
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >

                    {customers ? (
                      customers.map(customer => (
                        <MenuItem key={customer.id} value={customer.id}>
                          {customer.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="">No Data available</MenuItem>
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <Field
                    name="regionId"
                    component={TextField}
                    select
                    placeholder="Regions"
                    label="Regions"
                    variant="outlined"
                    margin="none"
                    fullWidth
                    disabled={!isAllCustomers}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >

                    {regions ? (
                      regions.map(region => (
                        <MenuItem key={region.id} value={region.id}>
                          {region.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="">No Data available</MenuItem>
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <Field
                    name="equipmentId"
                    component={TextField}
                    select
                    placeholder="Equipments"
                    label="Equipments"
                    variant="outlined"
                    margin="none"
                    fullWidth
                    disabled={!isAllCustomers}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
                    {equipments ? (
                      equipments.map(equipment => (
                        <MenuItem key={equipment.id} value={equipment.id}>
                          {equipment.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="">No Data available</MenuItem>
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <Field
                    name="agreementId"
                    component={TextField}
                    select
                    placeholder="Agreements"
                    label="Agreements"
                    variant="outlined"
                    margin="none"
                    fullWidth
                    disabled={!isAllCustomers}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
    
                    {agreements ? (
                      agreements.map(agreemnt => (
                        <MenuItem key={agreemnt.id} value={agreemnt.id}>
                          {agreemnt.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="">No Data available</MenuItem>
                    )}
                  </Field>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12}>
              <BaseButton
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}
                disabled={pristine || submitting}
              >
                {!isEditing ? "Send Notification" : "Update Notification"}
              </BaseButton>

              <BaseButton
                type="button"
                variant="outlined"
                className={classes.button}
                disabled={pristine || submitting}
                onClick={reset}
              >
                Clear
              </BaseButton>
            </Grid>
          </Grid>
        </form>
      </div>
    );
  }
}

NotificationsForm.defaultProps = {
  isEditing: false,
};

NotificationsForm.propTypes = {
  formInitValues: PropTypes.shape({
    regions: PropTypes.array,
    equipments: PropTypes.array,
    agreements: PropTypes.array,
  }),
};

const selector = formValueSelector("NotificationsForm");

const getMesssgeState = state => ({ 
  messageValue: selector(state, "message"),
  customerValue: selector(state, "customerId") 
});

NotificationsForm = compose(
  connect(getMesssgeState),
  withStyles(styles)
)(NotificationsForm);

export default reduxForm({
  form: "NotificationsForm",
})(NotificationsForm);
